export const FETCH_EMERGENCY_STATUS = 'FETCH_EMERGENCY_STATUS';
export const SET_EMERGENCY_STATUS = 'SET_EMERGENCY_STATUS';
export const SET_EMERGENCY_STATUS_SUCCESS = 'SET_EMERGENCY_STATUS_SUCCESS';
export const SET_EMERGENCY_STATUS_FAILURE = 'SET_EMERGENCY_STATUS_FAILURE';
export const EMERGENCY_STATUS_LOADING = 'EMERGENCY_STATUS_LOADING';
export const SET_EMERGENCY_KEY = 'SET_EMERGENCY_KEY';
export const SET_EMERGENCY_KEY_SUCCESS = 'SET_EMERGENCY_KEY_SUCCESS';
export const SET_EMERGENCY_KEY_FAILURE = 'SET_EMERGENCY_KEY_FAILURE';
